import { useState, forwardRef } from "react"
import { cn } from "@/lib/utils"

interface OptimizedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  eager?: boolean
}

const OptimizedImage = forwardRef<HTMLImageElement, OptimizedImageProps>(
  ({ eager, className, onLoad, ...props }, ref) => {
    const [loaded, setLoaded] = useState(false)

    return (
      <img
        ref={ref}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        className={cn(
          "transition-opacity duration-300",
          loaded ? "opacity-100" : "opacity-0",
          className,
        )}
        onLoad={(e) => {
          setLoaded(true)
          onLoad?.(e)
        }}
        {...props}
      />
    )
  },
)

OptimizedImage.displayName = "OptimizedImage"

export { OptimizedImage }
export type { OptimizedImageProps }
